/**
 * Owner mode is the dev server. Production never shows owner tools.
 * Do not add runtime switches here.
 *
 * Visitor preview (dev only) — see locally what production shows:
 *   localStorage.setItem('portfolio-preview-visitor', '1'); location.reload();
 *   localStorage.removeItem('portfolio-preview-visitor'); location.reload();
 */
const readVisitorPreviewActive = () => {
  try {
    return window.localStorage.getItem('portfolio-preview-visitor') === '1'
  } catch {
    return false
  }
}

const IS_DEV = process.env.NODE_ENV !== 'production'

export const IS_OWNER = IS_DEV && !readVisitorPreviewActive()
